import { Pipe, PipeTransform } from "@angular/core";
import { ObjectGroupViewModel } from "../../admin-panel/ObjectGroupViewModel";
import { ObjectLiteViewModel } from "app/models/ObjectLiteViewModel";
import { matchesSearchRule } from "./filterByProperty";

export enum ObjectFilterType {
  Name,
  IMEI,
  Phone,
  Equipment
}

export class ObjectsFilterModel {
  public filterType: ObjectFilterType = ObjectFilterType.Name;
  public term: string = "";
  public group: ObjectGroupViewModel;
  public companyIds: number[] = [];
}

function getObjectFilterValue(item: ObjectLiteViewModel, filterType: ObjectFilterType): string
{
  switch (filterType)
  {
    case ObjectFilterType.Name:
      return item.Name ?? "";
    case ObjectFilterType.IMEI:
      return item.IMEI ?? "";
    case ObjectFilterType.Phone:
      return item.Phone ?? "";
    case ObjectFilterType.Equipment:
      return item.Model ?? "";
    default:
      return "";
  }
}

@Pipe({
    name: 'objectsFilter',
    pure: false,
    standalone: false
})
// Applies the object filter with wildcard, separator, and exclusion rules.
export class FilterObjectsPipe implements PipeTransform
{
  transform(items: ObjectLiteViewModel[], filter: ObjectsFilterModel): ObjectLiteViewModel[]
  {
    if (!items) return [];

    if (filter.term)
    {
      const filteredItems: ObjectLiteViewModel[] = [];
      for (let i = 0; i < items.length; i++)
        if (matchesSearchRule(getObjectFilterValue(items[i], filter.filterType), filter.term))
          filteredItems.push(items[i]);

      items = filteredItems;
    }

    if (filter.group && filter.group.Id > 0)
    {
      const groupIDs = {};
      for (let i = 0; i < filter.group.objects.length; i++)
        groupIDs[filter.group.objects[i]] = 1;

      const filteredItems: ObjectLiteViewModel[] = [];
      for (let i = 0; i < items.length; i++)
        if (groupIDs[items[i].Id])
          filteredItems.push(items[i]);

      items = filteredItems;
    }

    if (filter.companyIds?.length)
    {
      const selectedCompanyIds = new Set<number>(filter.companyIds);
      const filteredItems: ObjectLiteViewModel[] = [];
      for (let i = 0; i < items.length; i++)
        if (selectedCompanyIds.has(items[i].CompanyId))
          filteredItems.push(items[i]);

      return filteredItems;
    }

    return items;
  }
}
